module.exports = __webpack_public_path__ + "img/gift.f0a2252c.svg";